var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status"},[_c('div',{class:[_vm.status ? 'active': 'inactive', 'ball']}),_c('span',[_vm._v(_vm._s(_vm.status ? 'Ativo' : 'Inativo'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }